export default __webpack_public_path__ + "static/media/single-5.b394d0e6.jpg";